<template>
  <div class="insights-ai-usage-summary-widget insights-widget">
    <div class="widget-wrapper">
      <div class="widget-common widget-small widget-full-height">
        <div class="widget-title d-flex align-items-baseline">
          AI usage
          <i
            v-tooltip="tooltipOptions"
            class="hi hi-info-filled ml-5"
            :title="infoTooltip"
          />
        </div>
        <div
          class="widget-body"
          :class="bodyClasses"
        >
          <template v-if="isReady">
            <InsightsNoData
              v-if="isEmptyWidget"
              :type="emptyReason"
            />
            <div
              v-else
              class="widget-details d-flex flex-column gap-15"
            >
              <div class="d-flex flex-column">
                <span class="value">{{ cost }}</span>
                <span class="property">Est. cost (benchmark, not spend)</span>
              </div>
              <div class="d-flex gap-30">
                <div class="d-flex flex-column">
                  <span class="value">{{ widgetData.members }}</span>
                  <span class="property">Members</span>
                </div>
                <div class="d-flex flex-column">
                  <span class="value">{{ number(widgetData.sessions) }}</span>
                  <span class="property">Sessions</span>
                </div>
                <div class="d-flex flex-column">
                  <span class="value">{{ number(widgetData.events) }}</span>
                  <span class="property">Events</span>
                </div>
              </div>
              <div class="d-flex gap-30">
                <div class="d-flex flex-column">
                  <span class="value">{{ number(widgetData.input_total) }}</span>
                  <span class="property">Input tokens</span>
                </div>
                <div class="d-flex flex-column">
                  <span class="value">{{ number(widgetData.output_total) }}</span>
                  <span class="property">Output tokens</span>
                </div>
                <div class="d-flex flex-column">
                  <span class="value">{{ number(widgetData.cache_total) }}</span>
                  <span class="property">Cache tokens</span>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { INSIGHTS } from '~/app_constants';
import { numericValue } from '~/utils/insights_utils';
import { Insights } from '~/mixins';
import { mapGetters } from 'vuex';

export default {
  name: 'InsightsAiUsageSummaryWidget',
  components: {
    InsightsNoData: () => import('~/components/insights/InsightsNoData.vue'),
  },
  mixins: [Insights],
  data: () => ({
    widgetKey: INSIGHTS.api.aiUsage.summary,
    tooltipOptions: Object.freeze({ html: true }),
    infoTooltip:
      'AI-agent usage (Claude Code / Codex) reported by the Hubstaff client apps. ' +
      'All $ figures are API rate-card equivalents — a usage benchmark, not actual subscription spend.',
  }),
  computed: {
    ...mapGetters({ widgetData: 'aiUsageSummary' }),
    cost() {
      const value = this.widgetData?.cost_usd || 0;

      return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    },
  },
  methods: {
    number(value) {
      return numericValue(value || 0, { maxNumberBeforeSymbol: 9999, roundDigits: 1 });
    },
  },
};
</script>
